angular.module('bmsApp.global').controller('ReminderModalCtrl', function ($scope,
																		  $modalInstance,
																		  $ngBootbox,
																		  ReminderSvc,
																		  remindable_type,
																		  remindable_id) {

	console.info('ReminderModalCtrl');

	var self = $scope.ReminderModalCtrl = {
		form: {
			options: {
				sendMethod: [
					{
						value: 'sms',
						label: 'SMS (Text)'
					},
					{
						value: 'email',
						label: 'E-mail'
					}
				]
			},
			data: {
				remindable_type: remindable_type,
				remindable_id: remindable_id
			},
			validator: {
				config: {
					submitHandler: function () {
						ReminderSvc.saveReminder(self.form.data)
							.then(function (response) {
								$modalInstance.close({
									success: true
								});
							}, function (errors) {
								self.errors = errors;
							})
							.finally(function () {
								self.form.processing = false;
							})
						;
					}
				},
				api: {}
			},
			processing: false
		},
		methods: {
			cancel: function () {
				$ngBootbox.confirm('Are you sure you want to do this?')
					.then(function () {
						$modalInstance.dismiss('cancel');
					});
			}
		},
		loading: true,
		errors: null
	};

});
